const colorModeReducers = (state = false, action) => {
  switch (action.type) {
    case "openColorMode":
      return (state = true);
    case "closeColorMode":
      return (state = false);
    default:
      return state;
  }
};
export default colorModeReducers;
